import React from 'react';
import { formatMontant } from '../../utils/format';
import { evaluerMarge, classesMarge } from '../../utils/marge';
import { TrendingUp, TrendingDown, AlertTriangle, HelpCircle } from 'lucide-react';

// Petite pastille de marge à afficher sous un champ prix ou sur une ligne
// de vente. Affiche le coût (PAM), le bénéfice unitaire et le taux.
//
// Props :
//   prix     : prix de vente (ou prix appliqué)
//   cout     : PAM (prix d'achat moyen) de la variante
//   seuilPct : seuil de marge faible (défaut 10)
//   compact  : version mono-ligne plus discrète (pour les lignes de vente)
export default function IndicateurMarge({ prix, cout, seuilPct = 10, compact = false }) {
  const { niveau, marge, taux } = evaluerMarge(prix, cout, seuilPct);

  if (niveau === 'inconnu') {
    if (!cout || Number(cout) <= 0) {
      return (
        <span className={`inline-flex items-center gap-1 text-[11px] ${compact ? '' : 'mt-1'} text-gray-500`}>
          <HelpCircle size={12} /> Coût inconnu (pas encore approvisionné)
        </span>
      );
    }
    return null;
  }

  const Icon = niveau === 'perte' ? TrendingDown
    : niveau === 'faible' ? AlertTriangle
    : TrendingUp;

  const signe = marge >= 0 ? '+' : '−';
  const tauxAbs = Math.abs(taux).toFixed(0);
  const margeAbs = formatMontant(Math.abs(marge));

  const texte = niveau === 'perte'
    ? (marge === 0
        ? `Aucune marge : prix = coût d'achat (${formatMontant(cout)})`
        : `Vente à perte : −${margeAbs} (${tauxAbs}%) · coût ${formatMontant(cout)}`)
    : niveau === 'faible'
      ? `Marge faible : ${signe}${margeAbs} (${signe}${tauxAbs}%) · coût ${formatMontant(cout)}`
      : `Marge : ${signe}${margeAbs} (${signe}${tauxAbs}%) · coût ${formatMontant(cout)}`;

  return (
    <span
      className={`inline-flex items-center gap-1.5 ${compact ? 'text-[11px] px-2 py-0.5' : 'text-xs mt-1 px-2.5 py-1'} rounded-lg border ${classesMarge(niveau)}`}
    >
      <Icon size={compact ? 12 : 14} className="flex-shrink-0" />
      <span>{texte}</span>
    </span>
  );
}
